import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { ToasterModule, ToasterService } from 'angular2-toaster';


declare interface RouteInfo {
	path: string;
	title: string;
	icon: string;
	class: string;
}

export const ROUTES: RouteInfo[] = [
	{ path: 'home', title: 'Companies',  icon: 'fa fa-building-o', class: '' },
	{ path: 'addcompany', title: 'Add company',  icon: 'fa fa-plus-square-o', class: '' },
	{ path: 'import', title: 'Import',  icon: 'fa fa-cloud-upload', class: '' },
	{ path: 'updatecompany', title: 'Update Company',  icon: '', class: 'hidden' },
	{ path: 'cpassword', title: 'Change Password',  icon: 'fa fa-user', class: '' },
	{ path:'systemanalytics', title:'System Analytics', icon:'fa fa-bar-chart', class: ''},
    { path:'appversion', title:'APP VERSION', icon:'fa fa-code-fork', class: ''},
	{ path:'onboarding-tutorial',title:'Add New Tutorials (beta version)', icon:'fa fa-plus-circle', class: '',},
	{ path: 'videosList',title:'Listing Of tutorials (beta version)', icon:'fa fa-list-alt', class: '',},
	{ path: 'logout', title: 'Logout',  icon:'fa fa-sign-out', class: 'hidden' },
	{ path:'ActivityLog', title:'Activity Logs', icon:'fa fa-check-circle', class: ''},
];

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit {

	private toasterService: ToasterService;
	menuItems: any[];
	currentPath: string;
	companiesCount: number;
	limit: number = 1000;
	skip: number = 0;

	constructor(private apiService: ApiService, private router:Router, toasterService: ToasterService) {
		this.toasterService = toasterService;
		router.events.subscribe(event => {
			if (event instanceof NavigationEnd ) {
				this.currentPath = event.url
			}
		});
	}

	ngOnInit() {
		this.menuItems = ROUTES.filter(menuItem => menuItem);
		if (localStorage.getItem('access_token')) {
			let params:any = {
				skip: this.skip,
				limit: this.limit,
				name:''
			}
			this.apiService.getAllCompanies(params).subscribe((data:any) => {
				this.companiesCount = data.data.totalCompanies;
			},
			error => {				
				if(error.statusText ==  "Unauthorized") {
					// window.open("/logout", "_self");
				} else
				 this.toasterService.pop('error', error.error.message);
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/sidebar/sidebar.component.ts